import { Button } from '@chakra-ui/react'
import { useTranslation } from 'next-i18next/pages'

export const VerifyFormButton = ({ onClick }: { onClick: () => void }) => {
  const { t } = useTranslation()
  return (
    <Button rounded={'2xl'} h={'56px'} w={'full'} onClick={onClick}>
      {t('verify.check-result')}
    </Button>
  )
}
